module.exports = __webpack_public_path__ + "img/menu_09.9a05c04.svg";